// Shared helpers for the History feature.
// All inputs (premium, dividends, purchase/sale price) are entered per share.
// Each option contract covers 100 shares, so actual money received = input × 100.
export const SHARES_PER_CONTRACT = 100;

export function computeTradeProfit(t) {
  let pl = Number(t.premium || 0) * SHARES_PER_CONTRACT;
  if (t.dividends != null) pl += Number(t.dividends) * SHARES_PER_CONTRACT;
  if (
    t.kind === "covered_call" &&
    t.purchase_price != null &&
    t.sale_price != null
  ) {
    pl += (Number(t.sale_price) - Number(t.purchase_price)) * SHARES_PER_CONTRACT;
  }
  return pl;
}

export function summarizeTrades(trades, car) {
  let premiums = 0;
  let dividends = 0;
  let assignmentPL = 0;
  for (const t of trades) {
    premiums += Number(t.premium || 0) * SHARES_PER_CONTRACT;
    if (t.dividends != null) dividends += Number(t.dividends) * SHARES_PER_CONTRACT;
    if (
      t.kind === "covered_call" &&
      t.purchase_price != null &&
      t.sale_price != null
    ) {
      assignmentPL +=
        (Number(t.sale_price) - Number(t.purchase_price)) * SHARES_PER_CONTRACT;
    }
  }
  const totalPL = premiums + dividends + assignmentPL;
  const pct = Number(car) > 0 ? (totalPL / Number(car)) * 100 : null;
  return { premiums, dividends, assignmentPL, totalPL, pct };
}

export const money = (n) =>
  n === null || n === undefined || n === "" || Number.isNaN(Number(n))
    ? "—"
    : `${Number(n) < 0 ? "-" : ""}$${Math.abs(Number(n)).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
